import api from "./api";

//  Servicio para obtener las ventas d eun inventario en especifico
export const getUserSales = async (inventario, rango, fecha) => {
  try {
    const response = await api.get('sells/user/', {
      params: { inventario, rango, fecha }
    });

    if (response.data.success) {
      return response.data.ventas;
    } else {
      console.warn("La respuesta no fue exitosa:", response.data);
      return [];
    }
  } catch (error) {
    console.error("❌ Error al obtener las ventas del usuario:", error);
    throw error;
  }
};
